<script setup lang="ts">
	const props = defineProps<{
		otpValue: string
		verifying?: boolean
	}>()
	const isVerifyingOtp = shallowRef(false)
	const otp = shallowRef('')
	const countdownTemplate = useTemplateRef('countdown')

	const emits = defineEmits<{
		(arg: 'update:otpValue', param: string | number): void
		(arg: 'done', param?: string | number): void
		(arg: 'resendOtp'): void
	}>()

	const submitOtp = () => {
		if (String(props.otpValue).length === 4) {
			isVerifyingOtp.value = true
			emits('done', otp.value)
		}
	}

	const resendOtp = () => {
		emits('resendOtp')
		if (countdownTemplate.value?.startCountdown) {
			countdownTemplate.value.startCountdown()
		}
	}
	onUnmounted(() => {
		if (countdownTemplate.value?.stopCountDown) {
			countdownTemplate.value.stopCountDown()
		}
	})

	watch(
		() => props.verifying,
		e => {
			isVerifyingOtp.value = e
		}
	)
</script>

<template>
	<div class="w-full">
		<div class="flex flex-col items-center justify-around">
			<forms-otp v-model:value="otp" @update:value="e => emits('update:otpValue', e)" />
			<p class="my-7 text-base text-gray-600">
				{{
					Number(countdownTemplate?.minutes ?? 0) == 0 && Number(countdownTemplate?.seconds ?? 0) == 0
						? "Didn't receive a code? "
						: 'Resend otp in:'
				}}
				<tools-countdown ref="countdown">
					<span
						class="cursor-pointer border-b-[3px] border-dotted text-primary-2"
						aria-roledescription="button"
						role="button"
						@click="resendOtp"
					>
						Resend
					</span>
				</tools-countdown>
			</p>

			<a-button
				block
				class="default-btn my-[3rem] w-full justify-center bg-primary-2"
				:disabled="isVerifyingOtp || String(otpValue).length < 4"
				:loading="isVerifyingOtp"
				data-testid="verify-email"
				@click="submitOtp"
			>
				Verify Email
			</a-button>
		</div>
	</div>
</template>
